import React, { useState, useEffect } from "react";
import personaService from "../services/persona.service";
import usuarioService from "../services/usuario.service";
import proyectoService from "../services/proyecto.service";

const AddUsuario = () => {
    const [cc, setCC] = useState([]);
    const [proyectos, setProyectos] = useState([]);
    const [usuario, setUsuario] = useState('');
    const [editable, setEditable] = useState(false);

    useEffect(()=>{
        retreiveCC();
    }, []);

    function retreiveCC() {
        personaService.getCC()
        .then(resp=>{
            console.log(resp);
            setCC(resp.data);
        })
        .catch(err=>{
            console.error(err);
        });
    }

    const handleProyecto = (e) => {
        console.log("E", e);
        if(e.target.checked) {
            proyectos.push({nombre: e.target.value});
            setProyectos([...proyectos]);
        } else {
            var inx = proyectos.findIndex(proy=>proy.nombre === e.target.value);
            if(inx >=0) {
                proyectos.splice(inx, 1);
                setProyectos([...proyectos]);
            }
        }
        console.log("Proyectos", proyectos);
    }

    const handleUsuario = (valor, nombre) => {
        setUsuario({...usuario, [nombre]: valor});
    }

    const onBlurUsuario = (e) => {
        usuarioService.getByMail({correo: e.target.value})
        .then(resp=>{
            console.log(resp);
            if(resp.data) {
                setEditable(true);
                setUsuario(resp.data);
                setProyectos(resp.data.proyectos);
            }
        })
        .catch(err=>{
            console.error(err);
        });
    }

    const crearUsuario = (e) => {
        e.preventDefault();
        usuarioService.create(usuario)
        .then(resp=>{
            if(resp.data) {
                //ingresamos los proyectos
                for(var i in proyectos) {
                    const datap = {
                        nombre: proyectos[i],
                        usuarioId: resp.data.id
                    }
                    console.log(datap);
                    proyectoService.create({nombre: proyectos[i].nombre, usuarioId: resp.data.id})
                    .then(resp=>{
                        console.log(resp);
                    })
                    .catch(err=>{
                        console.error(err);
                    })
                }
            }
        })
        .catch(err=>{
            console.error(err);
        });
    }

    const actualizarUsuario = (e) => {
        e.preventDefault();
        //Eliminamos los proyectos
        for(var i in proyectos) {
            if(proyectos[i].id) {
                proyectoService.delete(proyectos[i].id)
                .then(resp=>{
                    console.log(resp.data);
                })
                .catch(err=>{
                    console.error(err);
                });
            }
        }

        //Ingresamos los proyectos
        for(var i in proyectos) {
            //console.log("Ingresando...", proyectos[i]);
            proyectoService.create({nombre: proyectos[i].nombre, usuarioId: usuario.id})
            .then(resp=>{
                console.log(resp.data);
            })
            .catch(err=>{
                console.error(err);
            });
        }
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <form>
                        <div className="mb-3">
                            <label className="form-label">Correo:</label>
                            <input type="text" className="form-control" onChange={(e)=>handleUsuario(e.target.value, "correo")} onBlur={(e)=>onBlurUsuario(e)} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Password:</label>
                            <input type="password" className="form-control" onChange={(e)=>handleUsuario(e.target.value, "password")} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Proyecto:</label>
                            {cc.map((item, i)=>{
                                return (
                                    <div className="form-check" key={i}>
                                        <input className="form-check-input" value={item.ctoDescripcion} type="checkbox" onChange={(e)=>handleProyecto(e)} checked={proyectos.find(v=>v.nombre === item.ctoDescripcion) ? true : false} />
                                        <label className="form-check-label">{item.ctoDescripcion}</label>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="mb-3">
                            {editable ? (
                                <button className="btn btn-success" onClick={actualizarUsuario}>Actualizar</button>
                            ) : (
                                <button className="btn btn-primary" onClick={crearUsuario}>Ingresasr</button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddUsuario;